// src/components/TimeBadge.jsx
export default function TimeBadge({ basis = "current" }) {
  const isCurrent = basis === "current";
  const style = {
    backgroundColor: isCurrent ? "#00B074" : "#F4C542",
    color: isCurrent ? "#ffffff" : "#000000",
    borderRadius: "9999px",
    padding: "2px 10px",
    fontSize: "12px",
    fontWeight: 600,
    display: "inline-block",
    lineHeight: 1.6,
  };
  return <span style={style}>{isCurrent ? "Current Month" : "Last 3 Full Months"}</span>;
}
